export const findData = (data, dataIndex) => {
  if (!Array.isArray(dataIndex)) {
    return data[dataIndex];
  }
  let d = data[dataIndex[0]];
  for (let i = 1; i < dataIndex.length; i++) {
    if (dataIndex[i]) {
      d = d[dataIndex[i]];
    }
  }
  return d;
};
